import { Components, Theme } from '@mui/material'

export const MuiSwitch: Components<Omit<Theme, 'components'>>['MuiSwitch'] = {
  defaultProps: {
    size: 'medium',
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      padding: 0,
      borderRadius: theme.shape['radius-full'],
      // Fade the whole control like Checkbox/Radio, not just the track
      '&:has(.MuiSwitch-switchBase.Mui-disabled)': {
        opacity: 0.3,
      },
      '& .MuiSwitch-switchBase': {
        padding: theme.spacing(0.5),
        // Unchecked
        '& .MuiSwitch-thumb': {
          boxShadow: theme.customShadows.xs,
          backgroundColor: theme.palette.fg.success.onSuccess,
        },
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.bg.neutral.default,
        },
        '&:not(.Mui-disabled):hover + .MuiSwitch-track': {
          backgroundColor: theme.palette.bg.neutral.hover,
        },

        // Checked
        '&.Mui-checked + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.bg.success.default,
        },
        '&:not(.Mui-disabled).Mui-checked:hover + .MuiSwitch-track': {
          backgroundColor: theme.palette.bg.success.hover,
        },

        // MUI fades the disabled track to 0.12 by default; the root fades the whole control instead
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 1,
        },
      },
    }),
  },
  variants: [
    {
      props: { size: 'small' },
      style: {
        height: 16,
        width: 26,
        '& .MuiSwitch-thumb': {
          width: 12,
          height: 12,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
          transform: 'translateX(10px)',
        },
      },
    },
    {
      props: { size: 'medium' },
      style: {
        height: 20,
        width: 34,
        '& .MuiSwitch-thumb': {
          width: 16,
          height: 16,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
          transform: 'translateX(14px)',
        },
      },
    },
  ],
}
